import store from '@/store';
import { api } from '@/utils/api';
import axios from '@axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchItemGroups(ctx, queryParams) {
      console.log('=== ItemGroupStoreModule fetchItemGroups():', { queryParams });

      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;
        console.log('=== ItemGroupStoreModule businessID', businessID);

        const params = {
          businessID,
          pageNumber: queryParams.page || 1,
          pageSize: queryParams.perPage || 10,
          searchTerm: queryParams.q || '',
        };

        // Only add groupType filter if it has a valid value (not null or undefined)
        if (queryParams.groupType !== null && queryParams.groupType !== undefined) {
          params.groupType = queryParams.groupType;
        }

        console.log('=== ItemGroupStoreModule params', params);

        api
          .get(`/ItemGroups/GetByPagination/${businessID}`, { params })
          .then((response) => {
            console.log('=== ItemGroupStoreModule response', response.data);

            if ('status' in response.data && response.data.status === 'success') {
              // Check if the response has the expected structure
              const responseData = response.data.data;
              console.log('=== ItemGroupStoreModule responseData structure:', responseData);
              
              // Handle different possible response structures
              let results = [];
              let pagination = { totalCount: 0 };
              
              if (Array.isArray(responseData)) {
                // If responseData is directly an array
                results = responseData;
                pagination = { totalCount: responseData.length };
              } else if (responseData && typeof responseData === 'object') {
                // If responseData is an object, look for results/items
                results = responseData.results || responseData.items || responseData.data || [];
                pagination = responseData.pagination || { totalCount: results.length };
              }
              
              console.log('=== ItemGroupStoreModule processed results:', results);
              console.log('=== ItemGroupStoreModule pagination:', pagination);
              
              // Add serial numbers to the data
              const items = Array.isArray(results) ? results.map((item, index) => ({
                ...item,
                serialNo: (queryParams.page - 1) * queryParams.perPage + index + 1
              })) : [];
              
              resolve({
                items,
                pagination
              });
            } else {
              reject('Error fetching Item Groups list');
            }
          })
          .catch((error) => reject(error));
      });
    },
    fetchItemGroup(ctx, { id }) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;

        console.log(
          '=== ItemGroupStoreModule fetchItemGroup called with id:',
          id,
          'businessID:',
          businessID
        );

        api
          .get(`/ItemGroups/LoadSelectedData/${id}/${businessID}`)
          .then((response) => {
            console.log('=== ItemGroupStoreModule fetchItemGroup raw response:', response);
            console.log('=== ItemGroupStoreModule fetchItemGroup response.data:', response.data);

            if ('status' in response.data && response.data.status === 'success') {
              console.log(
                '=== ItemGroupStoreModule fetchItemGroup resolved data:',
                response.data.data
              );
              resolve(response.data.data);
            } else {
              console.error(
                '=== ItemGroupStoreModule fetchItemGroup invalid response:',
                response.data
              );
              reject('Error fetching Item Group data');
            }
          })
          .catch((error) => {
            console.error('=== ItemGroupStoreModule fetchItemGroup error:', error);
            reject(error);
          });
      });
    },
    fetchAllItemGroups(ctx) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;

        const params = {
          businessID,
          pageNumber: 1,
          pageSize: 1000, // Get all item groups
          searchTerm: '',
        };

        api
          .get(`/ItemGroups/GetByPagination/${businessID}`, { params })
          .then((response) => {
            if ('status' in response.data && response.data.status === 'success') {
              resolve(response.data.data.items || []);
            } else {
              reject('Error fetching all Item Groups');
            }
          })
          .catch((error) => reject(error));
      });
    },

    addItemGroup(ctx, itemGroupData) {
      const businessID = store.state.user.businessID;
      const userID = store.state.user.userID || store.state.user.id || 1;

      // Prepare payload with correct structure and field names
      const payload = {
        itemGroup: {
          id: itemGroupData.id || 0,
          code: itemGroupData.code || '',
          name: itemGroupData.name || '',
          groupType: itemGroupData.type || 'D', // Map 'type' to 'groupType'
          parentID: itemGroupData.parentID || null,
          itemType: itemGroupData.itemType || '',
          isActive: itemGroupData.isActive !== undefined ? itemGroupData.isActive : true,
          addedBy: userID,
          addedOn: new Date().toISOString(),
          updatedBy: userID,
          updatedOn: new Date().toISOString(),
          metaAddedBy: store.state.user?.fullName || store.state.user?.name || '',
          metaUpdatedBy: store.state.user?.fullName || store.state.user?.name || '',
          businessID: businessID,
          isDeleted: false,
          deletedByUserID: 0,
        },
      };

      console.log('=== ItemGroupStoreModule addItemGroup payload:', payload);

      return new Promise((resolve, reject) => {
        api
          .post(`/ItemGroups/Save/${businessID}?userID=${userID}`, payload)
          .then((response) => {
            console.log('=== ItemGroupStoreModule addItemGroup response:', response);
            resolve(response);
          })
          .catch((error) => {
            console.error('=== ItemGroupStoreModule addItemGroup error:', error);
            reject(error);
          });
      });
    },
    editItemGroup(ctx, itemGroupData) {
      const businessID = store.state.user.businessID;
      const userID = store.state.user.userID || store.state.user.id || 1;

      // Prepare payload with correct structure and field names
      const payload = {
        itemGroup: {
          id: itemGroupData.id || 0,
          code: itemGroupData.code || '',
          name: itemGroupData.name || '',
          groupType: itemGroupData.groupType || 'D', // Map 'type' to 'groupType'
          parentID: itemGroupData.parentID || null,
          itemType: itemGroupData.itemType || '',
          isActive: itemGroupData.isActive !== undefined ? itemGroupData.isActive : true,
          addedBy: userID,
          addedOn: new Date().toISOString(),
          updatedBy: userID,
          updatedOn: new Date().toISOString(),
          metaAddedBy: store.state.user?.fullName || store.state.user?.name || '',
          metaUpdatedBy: store.state.user?.fullName || store.state.user?.name || '',
          businessID: businessID,
          isDeleted: false,
          deletedByUserID: 0,
        },
      };

      console.log('=== ItemGroupStoreModule editItemGroup payload:', payload);

      return new Promise((resolve, reject) => {
        api
          .post(`/ItemGroups/Save/${businessID}`, payload)
          .then((response) => {
            console.log('=== ItemGroupStoreModule editItemGroup response:', response);
            resolve(response);
          })
          .catch((error) => {
            console.error('=== ItemGroupStoreModule editItemGroup error:', error);
            reject(error);
          });
      });
    },
    deleteItemGroup(ctx, { id }) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;
        const userID = store.state.user.userID;

        api
          .delete(`/ItemGroups/Delete/${id}/${businessID}`)
          .then((response) => {
            console.log(response);
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    setItemGroupStatus(ctx, { id, status }) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;

        api
          .post(`/ItemGroups/SetStatus/${businessID}`, { id, status })
          .then((response) => {
            console.log(response);
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
  },
};
